import { z } from 'zod';
import { onlyDigits } from '../documents';
import { booleanQuery, idSchema, optionalText, paginationQuerySchema, requiredText } from './common';

const imeiField = z
  .string()
  .trim()
  .nullish()
  .refine((v) => !v || /^\d{14,16}$/.test(onlyDigits(v)), 'IMEI deve ter 15 dígitos')
  .transform((v) => (v === undefined ? undefined : v ? onlyDigits(v) : null));

/** Campos do equipamento (sem o cliente) — usado também no cadastro rápido dentro da OS. */
export const equipmentFieldsSchema = z.object({
  categoryId: z.string({ required_error: 'Categoria é obrigatória' }).uuid('Selecione a categoria'),
  brand: requiredText(60, 'Marca'),
  model: requiredText(80, 'Modelo'),
  color: optionalText(40, 'Cor'),
  serial: optionalText(60, 'Número de série'),
  imei: imeiField,
  specs: optionalText(160, 'Armazenamento / configuração'),
  accessories: optionalText(300, 'Acessórios'),
  notes: optionalText(2000, 'Observações'),
});

export const equipmentCreateSchema = equipmentFieldsSchema.extend({ clientId: idSchema });
export const equipmentUpdateSchema = equipmentCreateSchema.partial();
export type EquipmentFieldsInput = z.infer<typeof equipmentFieldsSchema>;
export type EquipmentCreateInput = z.infer<typeof equipmentCreateSchema>;
export type EquipmentUpdateInput = z.infer<typeof equipmentUpdateSchema>;
export type EquipmentFormValues = z.input<typeof equipmentCreateSchema>;

export const equipmentListQuerySchema = paginationQuerySchema.extend({
  clientId: idSchema.optional(),
  categoryId: idSchema.optional(),
  includeInactive: booleanQuery,
});
